import { apiType, generateCrud } from './helpers'

/**
 * Converts the given entities into request payload data to the API endpoint.
 * @param {Object} entities Entity object
 * @return {Object}
 */
function convertToData (entities = []) {
  const data = {
    polls: [],
    surveys: [],
    competitions: [],
    groups: []
  }

  entities.forEach(entity => {
    const type = apiType(entity)
    data[`${type}s`].push(entity.id)
  })

  return data
}

export default function (id) {
  const path = id ? `/api/reports/${id}` : '/api/reports'
  const crud = generateCrud(path)

  return {
    create ({ entities, type, name, presenterId }) {
      const opts = {
        ...convertToData(entities),
        name,
        report_type: type
      }

      if (presenterId) {
        opts.filters = {
          presenter_ids: [presenterId]
        }
      }

      return crud.create(opts)
    },
    update: crud.update
  }
}
